import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const OfferForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        image: editData?.image || '',
        title: editData?.title || '',
        sub_title: editData?.sub_title || '',
        offer_percentage: editData?.offer_percentage || '',
        button_text: editData?.button_text || '',
        button_link: editData?.button_link || '',
        description: editData?.description || '',
        success_count: editData?.success_count || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };

    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Image' required />

                <ReactInput name='image' type='file' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Title' required />

                <ReactInput name='title' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Sub_title' required />

                <ReactInput name='sub_title' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Offer (%)' required />

                <ReactInput name='offer_percentage' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Button Text' required />

                <ReactInput name='button_text' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Button Link' required />

                <ReactInput name='button_link' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Success Count' required />

                <ReactInput name='success_count' type='number' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Description' required />

                <ReactInput name='description' as='textarea' rows={6} />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default OfferForm;
